import UserContext from 'src/services/UserContext';
import * as api from '../api/alertResults.api';
import {
  SourceOwners,
  SourceOwnersItem,
  InsertionDates,
  ClientRegions,
  CompetitorSites,
  CompetitorSitesItem,
  CompetitorSellers,
  CompetitorFulfillers,
} from '../api/alertResults.api';

export type AlertItem = {
  alertId: string;
  alertName: string;
};

export type InsertionDate = {
  id: string;
  value: string;
  label: string;
};

type Option = {
  value: string;
  label: string;
};

export type OptionGroup = {
  label: string;
  options: Option[];
};

const convertTimestamp = (timestamp?: string, format?: string) => {
  return UserContext.reformatUTCDate(timestamp, format) ?? '';
};

export const getInsertionDateId = (timestamp?: string) => {
  return convertTimestamp(timestamp, 'YYYY-MM-DD');
};

export const getSourceOwner = async (params: SourceOwners.Request): Promise<SourceOwnersItem[]> => {
  const { sourceOwner } = await api.getSourceOwner(params);
  return sourceOwner;
};

export const getAlerts = async (userEmail: string): Promise<AlertItem[]> => {
  const { alerts } = await api.getAlerts(userEmail);
  return alerts.map((item) => ({
    alertId: String(item.alertId),
    alertName: item.alertName,
  }));
};

export const getInsertionDates = async (params: InsertionDates.Request): Promise<InsertionDate[]> => {
  const { alertResultDateList } = await api.getInsertionDates(params);
  return alertResultDateList.alertResultDates.map((timestamp: string) => ({
    id: getInsertionDateId(timestamp),
    value: timestamp,
    label: convertTimestamp(timestamp, 'MMMM D, YYYY'),
  }));
};

export const getClientRegions = async (params: ClientRegions.Request): Promise<OptionGroup[]> => {
  const { Regions } = await api.getClientRegions(params);
  return Regions.map((regionGroup) => ({
    label: regionGroup.regionGroupName,
    options: regionGroup.region.map((region) => ({
      value: String(region.Id),
      label: region.value,
    })),
  }));
};

export const getCompetitorSites = async (params: CompetitorSites.Request): Promise<CompetitorSitesItem[]> => {
  const { competitorList } = await api.getCompetitorSites(params);
  return competitorList;
};

export const getCompetitorSellers = async (params: CompetitorSellers.Request): Promise<string[]> => {
  const { sellerList } = await api.getCompetitorSellers(params);
  return sellerList.sellers;
};

export const getCompetitorFulfillers = async (params: CompetitorFulfillers.Request): Promise<string[]> => {
  const { fulfillerList } = await api.getCompetitorFulfillers(params);
  return fulfillerList.fulfillers;
};
